import React from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";

const Policies = () => {
  return (
    <>
      <Navbar/>

      <div className="container my-5">
        <h2>Privacy Policy</h2>
        <p>Last updated on Mar 3, 2025</p>
        <p>
          This privacy policy sets out how Irfan Electricals uses and protects any
          information that you give Irfan Electricals when you visit their website
          and/or agree to purchase from them.
        </p>
        <p>
          Irfan Electricals is committed to ensuring that your privacy is
          protected. Should we ask you to provide certain information by which you
          can be identified when using this website, you can be assured that it
          will only be used in accordance with this privacy statement.
        </p>
        <p>
          Irfan Electricals may change this policy from time to time by updating
          this page. You should check this page periodically to ensure that you
          adhere to these changes.
        </p>

        <h4>Information We Collect</h4>
        <ul>
          <li>Name</li>
          <li>Contact information including email address</li>
          <li>Demographic information such as postcode, preferences, and interests</li>
          <li>Other information relevant to customer surveys and/or offers</li>
        </ul>

        <h4>What We Do with the Information</h4>
        <p>
          We require this information to understand your needs and provide you with
          a better service, including:
        </p>
        <ul>
          <li>Internal record keeping</li>
          <li>Improving our products and services</li>
          <li>
            Sending promotional emails about new products, special offers, or
            other information
          </li>
          <li>
            Contacting you for market research purposes via email, phone, fax, or mail
          </li>
          <li>Customizing the website according to your interests</li>
        </ul>

        <h4>Security</h4>
        <p>
          We are committed to ensuring that your information is secure. In order to
          prevent unauthorized access or disclosure, we have put in place suitable
          security measures.
        </p>

        <h4>Cookies</h4>
        <p>
          We use cookies to analyze web traffic and improve our website. You can
          choose to accept or decline cookies through your browser settings.
        </p>

        <h4>Controlling Your Personal Information</h4>
        <p>
          You may choose to restrict the collection or use of your personal
          information by opting out of direct marketing or contacting us at
          info@irfanelectricals.com.
        </p>

        <h2>Cancellations and Refund Policy</h2>
        <p>
          At Irfan Electricals, we strive for customer satisfaction. However, cancellations and refunds are not accepted.
        </p>
      </div>
      <Footer/>
    </>
  );
};

export default Policies;
